<template>    
  <v-container> 
    <v-layout row wrap>
      <v-flex xs12 offset-xs9>
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-checkbox v-model="show_non_active" label="Pokaż nieaktywnych"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-btn color="info" @click="addNew">Dodaj nowego użytkownika</v-btn>
            </v-col>
          </v-row>
        </v-container>


      </v-flex>
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"
              :server-items-length="totalResults"              
              :footer-props="{
                        itemsPerPageOptions:[100,200],
              }"  
              :headers="headers">
                <template v-slot:item.isActive="{item}">
                  {{ item.isActive == true ? "Tak" : "Nie" }}                  
                </template>
                <template v-slot:item.id="{item}">
                    <v-layout align-center>                           
                      <v-icon small class="mr-2" @click="editUser(item.id)" v-if="item.name != 'admin'" title="Edytuj użytkownika">fa-user-edit</v-icon>
                      <v-icon small class="mr-2"  @click="changePassword(item.id)" v-if="item.name != 'admin'" title="Zmień hasło">fa-lock</v-icon>
                      <v-icon small class="mr-2"  @click="reset2FA(item.id)" v-if="item.name != 'admin' && item.twoFactorEnabled" title="Zresetuj ustawienia 2FA">fa-lock-open</v-icon>
                    </v-layout>                  
                </template>
          <template v-slot:item.twoFactorEnabled="{item}">
            {{ item.twoFactorEnabled == true ? "Tak" : "Nie" }}
          </template>
        </v-data-table>    
        <AddEditUser v-if="showAddEditUser" :visible="showAddEditUser" :id="selectedUserId" @close="closeAddPopup"/>
        <ResetPassword :visible="showResetPassword" :id="selectedUserId" @close="showResetPassword = false" />
      </v-flex>
    </v-layout>        
  </v-container>
</template>

<script>
import {  mapActions } from "vuex";
import { userService} from "@/services/";
import AddEditUser from "./AddEditUser";
import ResetPassword from "./ResetPassword"
import swal from "sweetalert";
export default {
    name: 'UsersAdmin',
    data() {
        return {
            showAddEditUser: false,
            showResetPassword: false,
            totalResults: 0,
            selectedUserId: 0,
            show_non_active: false,
            loading: true,
            items: [],
            pagination: {},
            headers: [
              { text: 'Nazwa', sortable: true, align: 'left', value: 'userName'},
              { text: 'Imię', sortable: true, align: 'left', value: 'name'},
              { text: 'Nazwisko', sortable: true, align: 'left', value: 'surname'},
              { text: 'Email', sortable: true, align: 'left', value: 'emailAddress'},
              { text: 'Aktywny', sortable: true, align: 'left', value: 'isActive'},
              { text: 'Autoryzacja 2FA', sortable: false, align: 'left', value: 'twoFactorEnabled'},
              { text: 'Akcje', sortable: false, align: 'left', value: 'id'} 
            ]
        }
    },
    watch: {
      pagination: {
        handler() {
          this.requestUsers().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
        },
        deep: true
      },
      show_non_active: {
        handler() {
          this.refreshTable()
        }
      }
    },
    components: {
      AddEditUser,
      ResetPassword
    },
    methods: {
        ...mapActions('title',['updateTitle']),
        ...mapActions("alert", ["error", "success"]),
        reset2FA(userid) {
          swal({
            title: "Czy na pewno?",
            text:
                "Zresetowanie ustawień 2FA spowoduje, że użytkownik będzie musiał ponownie skonfigurować uwierzytelnianie dwuetapowe. Czy na pewno chcesz kontynuować?",
            icon: "warning",
            buttons: ["Nie", "Tak"],
            dangerMode: true
          }).then(confirmed => {
            if (confirmed) {
             userService.reset2FA(userid).then(() => {
               this.success("Zresetowano ustawienia 2FA");
             }).catch((err) => {
               console.log(err)
               this.error("Błąd resetowania ustawień 2FA");
             });
            }
          });
        },
        requestUsers() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
          let sortValue = ''
          if(sortBy.length > 0)
          {
            sortValue = sortBy[0]
            if(sortDesc.length > 0)
              sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
          }
            var req = userService.getAll({ query: '', page: page, limit: itemsPerPage, sorting: sortValue, isActive: this.show_non_active ? false : true });
            
            return req.catch(() => {
                this.error("Błąd pobierania użytkowników");
                this.loading = false;
            });
        },
        addNew() {
          this.selectedUserId = 0
          this.showAddEditUser = true
        },
        refreshTable()
        {
          this.loading = true

          this.requestUsers().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
        },
        closeAddPopup() {
            this.showAddEditUser = false
            this.selectedUserId = 0
            this.refreshTable()
        },
        changePassword(id)
        {
            this.showResetPassword = true
            this.selectedUserId = id
        },
        editUser(id) {
            this.selectedUserId = id
            this.showAddEditUser = true
        }
    },
    created()
    {
        this.updateTitle('Administracja systemem - zarządzanie użytkownikami')
    }
}
</script>

<style>    
  .data-table-poko #users {
    margin-top: 60px;
  }
</style>
